<template>
  <div id="app-main">
    <el-row>
      <el-col>
        <div class="page-title-box">
          <h4 class="page-title">课程图谱列表</h4>
        </div>
      </el-col>
    </el-row>
    <el-row class="mb-3">
      <el-col class="flex-between">
        <div class="select-auto-fit-style">
          <el-select
            class="schoolyear range-condition"
            v-model="schoolyear"
            @change="handleSchoolyear"
            placeholder="请选择学期"
            filterable
          >
            <template slot="prefix">
              {{ (schoolyearOption.find((v) => v.id === schoolyear) || {}).name }}
            </template>
            <el-option v-for="item in schoolyearOption" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select
            class="institute range-condition"
            v-model="institute"
            @change="handleInstitute"
            placeholder="请选择类别"
            filterable
          >
            <template slot="prefix">
              {{ (instituteOption.find((v) => v.id === institute) || {}).name }}
            </template>
            <el-option
              v-for="item in instituteOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              :class="!item.disabled && item.env === 'sysu' ? 'level2-option' : ''"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </div>
        <div class="flex">
          <!-- <el-input v-model="keyword" placeholder="请输入图谱名称搜索" @change="handleKeyword"></el-input>
          <el-button type="primary" class="btn-search" @click="handleKeyword">
            <i class="mdi mdi-magnify"></i>
          </el-button> -->
          <el-button type="success" @click="handleShowAddGraphDialog" v-if="![6, 7].includes(userInfo.role_id)">新增能力图谱</el-button>
        </div>
      </el-col>
    </el-row>
    <el-card shadow="never" v-if="this.totalSize > 0" class="mb-2">
      <el-row :gutter="20" class="mt-3 mx-2">
        <el-col class="flex-course-card" v-for="item in courseGraphList" :key="item.id">
          <div class="course-box" @click="courseDetail(item.course_id)">
            <div class="cover-img">
              <div class="img-src" :style="{ backgroundImage: 'url(' + item.img_url + ')' }"></div>
            </div>
            <div class="course-content card-box flex-start flex-column">
              <div class="teacher-name" :title="item.fullname">{{ item.fullname }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-row v-if="this.totalSize > 0" class="flex-between flex-align-center">
      <el-col>
        <div>共{{ totalSize }}个图谱</div>
      </el-col>
      <Pagination
        :pageSizes="[12, 24, 60, 120]"
        :perSize="pageSizesVal"
        :totalSize="totalSize"
        :currentPage="currentPage"
        @setPageSizesVal="getPageSizesVal"
        @setCurPageVal="getCurPageVal"
      ></Pagination>
    </el-row>
    <el-row v-else>
      <el-col class="flex-center-center empty-course flex-column">
        <img width="250px" src="@/assets/images/course/pic_result_nocourse@2x.png" />
        <div class="empty-course-tips">没有匹配的图谱</div>
      </el-col>
    </el-row>
    <el-dialog title="新增能力图谱" :visible.sync="dialogAddGraphVisible" width="30%" :close-on-click-modal="false">
      <el-form label-width="80px" label-position="top">
        <el-form-item label="尚未配置的课程">
          <el-select v-model="newGraphId" style="width: 100%;">
            <el-option v-for="item in noMapGraphList" :key="item.course_id" :label="item.fullname" :value="item.course_id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAddGraphDialog">取消</el-button>
        <el-button type="primary" @click="handleConfirmAddGraph" :disabled="!newGraphId">确认添加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue'
import { getCascader } from '@/utils/format.js'
import { mapState } from 'vuex'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      schoolyear: '0',
      schoolyearOption: [],
      institute: '0',
      instituteOption: [],
      keyword: '',
      courseGraphList: [],
      // 页码数据
      totalSize: 0,
      currentPage: 1,
      pageSizesVal: 12,
      dialogAddGraphVisible: false,
      newGraphId: '',
      noMapGraphList: [],
    }
  },
  computed: {
    ...mapState({
      userInfo(state) {
        return state.commom.userInfo
      },
      roleList(state) {
        return state.commom.roleList
      },
      routesStartPath() {
        // console.log('this.$route.path', this.$route.path)
        return this.$route.path
      },
    }),
  },
  mounted() {
    console.log('roleList', this.roleList);
    Promise.all([this.getSemesterApi(), this.getCollegeApi()])
      .then(() => {
        this.getCapabilityCourseGraphList()
      })
      .catch((err) => {
        this.$message.warning(err)
      })
  },
  methods: {
    // 课程列表接口
    async getCapabilityCourseGraphList() {
      await this.$store
        .dispatch('capability/getCapabilityCourseGraphList', {
          semester_id: +this.schoolyear,
          category_id: +this.institute,
          keyword: this.keyword,
          page: this.currentPage,
          pagesize: this.pageSizesVal,
        })
        .then((res) => {
          console.log('res:', res)
          if (res.code === 1) {
            this.courseGraphList = res.data.list
            this.totalSize = res.data.paging.records
            console.log('courseGraphList', this.courseGraphList)
          }
        })
        .catch((err) => {
          return Promise.reject(err)
        })
    },
    // 获取学期接口
    async getSemesterApi() {
      await this.$store
        .dispatch('commom/getSemester')
        .then((res) => {
          console.log('res:', res)
          if (res.code === 1) {
            this.schoolyearOption = res.data
            if (this.schoolyearOption.length > 0) {
              this.schoolyear = this.schoolyearOption[0].id
            }
            this.schoolyearOption = [
              {
                id: '0',
                name: '全部学期',
              },
            ].concat(this.schoolyearOption)
          }
        })
        .catch((err) => {
          return Promise.reject(err)
        })
    },
    // 获取学院接口
    async getCollegeApi() {
      await this.$store
        .dispatch('commom/getCollege')
        .then((res) => {
          console.log('res:', res)
          if (res.code === 1) {
            this.instituteOption = []
            // 处理成树型数据
            let treeData = getCascader(res.data)
            // 根据环境处理数据
            switch (process.env.VUE_APP_MODE) {
              case 'sysu':
                for (let firstLevelItem of treeData) {
                  firstLevelItem.env = 'sysu'
                  this.instituteOption.push(firstLevelItem)
                  let childNodes = firstLevelItem.children
                  // 对每一个子节点都进行深度优先遍历
                  if (childNodes.length) {
                    childNodes.forEach((item) => {
                      item.env = 'sysu'
                      this.instituteOption.push(item)
                    })
                  }
                }
                break
              default:
                for (let firstLevelItem of treeData) {
                  firstLevelItem.env = 'others'
                  firstLevelItem.disabled = false
                  this.instituteOption.push(firstLevelItem)
                }
                break
            }
            this.instituteOption = [
              {
                id: '0',
                name: '全部类别',
              },
            ].concat(this.instituteOption)
          }
        })
        .catch((err) => {
          return Promise.reject(err)
        })
    },
    // 跳转课程详情
    courseDetail(courseId) {
      this.$router.push({
        path: '/ability-graph/detail',
        query: {
          courseId: courseId,
        },
      })
    },
    // 查询事件处理
    handleSchoolyear() {
      this.getCapabilityCourseGraphList()
    },
    handleInstitute() {
      this.getCapabilityCourseGraphList()
    },
    handleKeyword() {
      this.getCapabilityCourseGraphList()
    },
    handleShowAddGraphDialog() {
      this.newGraphId = ''
      this.$store.dispatch('capability/getCapabilityNoMapGraph').then((res) => {
        if (res.code === 1) {
          this.noMapGraphList = res.data
          this.dialogAddGraphVisible = true
        }
      })
    },
    handleCloseAddGraphDialog() {
      this.dialogAddGraphVisible = false
    },
    handleConfirmAddGraph() {
      this.$router.push({
        name: 'abilityConfigure',
        query: {
          courseId: this.newGraphId,
        },
      })
    },
    // 页码操作
    getPageSizesVal(pageSizesVal) {
      this.pageSizesVal = pageSizesVal
      this.getCapabilityCourseGraphList()
    },
    getCurPageVal(curPageVal) {
      this.currentPage = curPageVal
      this.getCapabilityCourseGraphList()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .schoolyear.el-select .el-input__inner {
    width: 180px;
    padding-left: 0;
    border: none;
    background: none;
    font-size: 20px;
    font-weight: bold;
    color: #3294f6;
  }
  .institute.el-select .el-input__inner {
    width: 240px;
    padding-left: 0;
    border: none;
    background: none;
    font-size: 20px;
    font-weight: bold;
    color: #3294f6;
  }
  .select-auto-fit-style .el-select .el-input .el-select__caret {
    color: #3294f6;
    font-weight: bold;
  }
  .select-auto-fit-style .el-select {
    .el-input__inner::placeholder {
      color: #3294f6;
    }
  }
  .el-input {
    .el-input__inner {
      border-radius: 3px;
    }
  }
  .btn-search.el-button--primary {
    width: 56px;
    height: 40px;
    padding: 11px;
    border-radius: 3px;
  }
  .select-auto-fit-style {
    .el-input__prefix {
      // prefix与input的样式保持一致，这样才能与原来重合对齐
      font-size: 20px;
      font-weight: bold;
      line-height: 40px;
      padding-right: 30px;
      left: 0;
      position: relative;
      visibility: hidden;
      text-align: center;
    }
    .el-input__inner {
      position: absolute;
    }
    .el-input__suffix {
      right: 0;
    }
  }
  .el-dialog {
    .el-dialog__body {
      padding: 0 16px;
    }
  }
}
.mdi.mdi-magnify {
  font-size: 25px;
  line-height: 18px;
}
.page-title-box {
  h4.page-title {
    font-weight: 600;
  }
}
.selectbox {
  margin-right: 11px;
}
.range-condition {
  margin-right: 24px;
}
.empty-course {
  height: 320px;
  background-color: white;
  background-repeat: no-repeat;
  background-clip: content-box;
  .empty-course-tips {
    margin-top: 24px;
    color: rgba(152, 166, 173, 1);
    font-size: 18px;
  }
}
.course-box {
  cursor: pointer;
  .cover-img {
    width: 100%;
    height: 146px;
    overflow: hidden;
    .img-src {
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-position-x: center;
      // background-position-y: center;
      background-size: cover;
    }
  }
  .source-cover {
    position: relative;
    height: 146px;
    overflow: hidden;
    .cover-img {
      position: absolute;
      top: 50%;
      left: 50%;
      display: block;
      min-width: 100%;
      min-height: 100%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }
  }

  .course-content {
    padding-top: 0 !important;
    .course-name {
      margin-top: 24px;
      color: rgba(52, 58, 64, 1);
      font-size: 18px;
      line-height: 18px;
      font-weight: bold;
      height: 36px;
      width: 100%;
      word-break: break-all;
      overflow: hidden;
    }
    .teacher-name {
      margin-top: 16px;
      font-size: 14px;
      line-height: 14px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.level2-option {
  padding-left: 30px;
}
@media screen and (min-width: 1700px) {
  .flex-course-card {
    width: 16.66667%;
  }
}
@media screen and (max-width: 1699px) {
  .flex-course-card {
    width: 25%;
  }
}
@media screen and (max-width: 1699px) {
  .flex-course-card {
    width: 25%;
  }
}
@media screen and (max-width: 1080px) {
  .flex-course-card {
    width: 33%;
  }
}
@media screen and (max-width: 780px) {
  .flex-course-card {
    width: 50%;
  }
}
@media screen and (max-width: 480px) {
  .flex-course-card {
    width: 100%;
  }
}
</style>
